export default class Video {
    constructor(el) {
        this.el = el
        this.wrapper = this.el.querySelector('.video-wrapper')
        this.video = this.el.querySelector('.video')
        this.play = this.el.querySelector('.play-btn')
        this.hasLoaded = false

        this.play.addEventListener('click', () => {
            if (this.hasLoaded) {
                this.wrapper.classList.remove('paused')
                this.wrapper.classList.add('playing')
                this.video.play()

                return
            }

            this.wrapper.classList.add('loading')
            this.video.src = this.video.getAttribute('data-src')

            this.video.addEventListener('canplay', () => {
                this.hasLoaded = true
                this.wrapper.classList.remove('loading')
                this.wrapper.classList.add('playing')

                this.video.play()
            }, { once: true })

            this.video.addEventListener('click', () => {
                if (this.wrapper.classList.contains('playing') && !this.wrapper.classList.contains('paused')) {
                    this.wrapper.classList.add('paused')
                    this.video.pause()
                }
            })

            this.video.addEventListener('ended', () => {
                this.wrapper.classList.remove('playing', 'paused')
            })
        })
    }
}